<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <h3 class="mb-4">{{ $t('push_notifications') }}</h3>
        <NotificationOptIn />
        <button class="btn btn-outline-secondary mt-4" @click="logout">
          {{ $t('logout') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import apiClient from '@/services/apiClient';
import NotificationOptIn from '@/components/NotificationOptIn.vue';

export default {
  name: 'PushuserDashboard',
  components: {
    NotificationOptIn,
  },
  methods: {
    async logout() {
      try {
        await apiClient.post('/api/v1/token/logout/');
      } catch (_) {
        // proceed with local cleanup even if server call fails
      }
      axios.defaults.headers.common['Authorization'] = '';
      localStorage.removeItem('username');
      localStorage.removeItem('userid');
      localStorage.removeItem('token');
      localStorage.removeItem('permissions');
      this.$store.commit('removeToken');
      this.$router.push('/');
    },
  },
};
</script>
